"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = exports.isEmptyObject = void 0;
/**
 * Пустой объект или нет
 * @param object - объект
 */
function isEmptyObject(object) {
    if (!object) {
        return true;
    }
    return Object.keys(object).length === 0;
}
exports.isEmptyObject = isEmptyObject;
/**
 * Пустая переменная или нет
 * @param value - значение переменной
 */
function isEmpty(value) {
    return value === undefined || value === null;
}
exports.isEmpty = isEmpty;
//# sourceMappingURL=index.js.map